import { useSelector } from "react-redux";
import "./UwPolicyInstallments.scss";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TablePagination,
    Chip,
} from "@mui/material";
import { motion } from "framer-motion";
import { ScaleLoader } from "react-spinners";
import newRequest from "../../../utils/newRequest";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { CustomLoadingButton } from "../../../components/ui/CustomButton";
import moment from "moment";
import numeral from "numeral";
import { useTranslation } from "react-i18next";

const UwPolicyInstallments = ({ policyDocid, plCurCode, installmentConfirmed }) => {
    const { t } = useTranslation();
    const { currentTheme } = useSelector((state) => state.theme);
    const navigate = useNavigate();
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [searchTerm, setSearchTerm] = useState("");
    const [currencyAction, setCurrencyAction] = useState("");
    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        action_invoked: "",
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const [policyInstallments, setPolicyInstallments] = useState([]);
    const [selectedInstallment, setSelectedInstallment] = useState(null);
    const [expectedFcAmount, setExpectedFcAmount] = useState(0);
    const [paidFcAmount, setPaidFcAmount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    const fetchPolicyInstallments = async () => {
        try {
            const res = await newRequest.get(`/uwPolicyInstallment/findAll/${policyDocid}`);
            // console.log(`res.data ${JSON.stringify(res.data, null, 2)}`);
            setPolicyInstallments(res.data);
            // Calculate the total after fetching
            const expectedFc = res.data.reduce((acc, row) => acc + parseFloat(row.ins_fc_amount || 0), 0);
            const paidFc = res.data.reduce((acc, row) => acc + parseFloat(row.paid_fc_amount_xx || 0), 0);
            setExpectedFcAmount(expectedFc);
            setPaidFcAmount(paidFc);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching excess types:", error);
        }
    };

    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const slicedInstallments = policyInstallments.slice(
        currentPage * rowsPerPage,
        currentPage * rowsPerPage + rowsPerPage
    );

    const handleRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 5));
        setCurrentPage(0);
    };

    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "deleteNumGen") {

            }
        } catch (err) {
            console.log(err);
        }
        // Close the dialog
        setIsConfirmDialogOpen(false);
    };

    const handleCancel = () => {
        setIsConfirmDialogOpen(false);
    };

    const handleCloseNotifyDialog = () => {
        setIsNotifyDialogOpen(false);
    };

    const formatNumber = (value, decimals = 2) => {
        if (isNaN(value)) return value;
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        }).format(value);
    };

    const handleChange = (e, id) => {
        try {
            const { name, value } = e.target;
            const updatedData = [...policyInstallments];
            const index = updatedData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                updatedData[index][name] = e.target.value;
                updatedData[index]["changed_xx"] = "Y";
                setPolicyInstallments(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleBlur = (e, id) => {
        try {
            const { name, value } = e.target;
            const updatedData = [...policyInstallments];
            const index = updatedData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                updatedData[index][name] = formatNumber(value, 2);
                setPolicyInstallments(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        try {
            fetchPolicyInstallments();
        } catch (error) {
            console.log(error)
        }
    }, [policyDocid]);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
            className="uw-policy-installments">
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                    />
                </div>
            ) : (
                <div className="uw-policy-installments-wrapper">
                    {/* Policy Installments */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "10px"
                        }}
                    >
                        <span className="sub-title">{`${policyInstallments?.length} ${t('installments').toUpperCase()}`}</span>
                        <span style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "5px",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <span className={`status Active`} style={{ marginLeft: "10px", height: "32px", alignContent: "center", alignItems: "center" }}>{`${t('paid').toUpperCase()} ${numeral(paidFcAmount).format("0,0.00")}`}</span>
                            <span className={`status Validated`} style={{ marginLeft: "10px", height: "32px", alignContent: "center", alignItems: "center" }}>{`${t('os').toUpperCase()} ${numeral(paidFcAmount - expectedFcAmount).format("0,0.00")}`}</span>
                        </span>
                    </div>
                    {policyInstallments?.length > 0 &&
                        <div className="table-content">
                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                <Table sx={{ width: "max-content", border: 'none' }}>
                                    <TableHead className="tablehead">
                                        <TableRow className="tablerow">
                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                #
                                            </TableCell>
                                            <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                                <span>{t('installment').toUpperCase()}</span>
                                            </TableCell>
                                            <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                                <span>{`${t('amount').toUpperCase()} [${plCurCode}]`}</span>
                                            </TableCell>
                                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                                <span>{t('paid').toUpperCase()}</span>
                                            </TableCell>
                                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                                <span>{t('outstanding').toUpperCase()}</span>
                                            </TableCell>
                                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                <span>{t('receipts').toUpperCase()}</span>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody className="tablebody">
                                        {slicedInstallments?.map((row, index) => (
                                            <TableRow
                                                key={row._id}
                                                className={`${selectedInstallment?._id === row._id ? "tablerow current" : "tablerow"}`}
                                                onClick={() => {
                                                    try {
                                                        setSelectedInstallment(row);
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                            >
                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                    <span>{row.ins_no}</span>
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                                    <span>{moment(row?.ins_date).format("DD-MMM-YYYY")}</span>
                                                </TableCell>
                                                <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                                    {installmentConfirmed !== "Y" &&
                                                        <div className="input-item-with-label">
                                                            <input
                                                                id="ins_fc_amount"
                                                                name="ins_fc_amount"
                                                                type="text"
                                                                value={formatNumber(row.ins_fc_amount, 2)}
                                                                onChange={(e) => handleChange(e, row._id)}
                                                                onBlur={(e) => handleBlur(e, row._id)}
                                                                style={{ width: "100%", textAlign: "right" }}
                                                                className="form-input-item table"
                                                            />
                                                        </div>}
                                                    {installmentConfirmed === "Y" && <span>{numeral(row.ins_fc_amount).format("0,0.00")}</span>}
                                                </TableCell>
                                                <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                                    <span>{row.fmt_paid_fc_amount_xx}</span>
                                                </TableCell>
                                                <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                                    <span>{row.fmt_os_fc_amount_xx}</span>
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                    {row.receipts_xx?.length > 0 &&
                                                        <div className="chip-wrapper" style={{ gap: "5px" }}>
                                                            {row.receipts_xx.map((row) => (
                                                                <Chip
                                                                    key={row.ln_hd_no_docid}
                                                                    label={`${row?.paid_to === "ToCarrier" ? row.ln_hd_no + " *" : row.ln_hd_no}`}
                                                                    className="chip"
                                                                    onClick={() => {
                                                                        try {
                                                                            if (row?.paid_to === "ToCarrier") {
                                                                                setNotifyDialogTitle("Note!");
                                                                                setNotifyDialogText(`This receipt ${row?.ln_hd_no} was receipted by carrier!`);
                                                                                setIsNotifyDialogOpen(true);
                                                                                return;
                                                                            } else {
                                                                                navigate(`/receipt/${row.ln_hd_no_docid}`);
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                />
                                                            ))}
                                                        </div>}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                {policyInstallments?.length > rowsPerPage &&
                                    <TablePagination
                                        rowsPerPageOptions={[10]}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleRowsPerPage}
                                        component="div"
                                        count={policyInstallments?.length}
                                        rows={policyInstallments}
                                        page={currentPage}
                                        onPageChange={handlePageChange}
                                    />}
                            </TableContainer>
                        </div>}
                    {/* End of installments table */}
                </div>
            )}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={handleCloseNotifyDialog}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={handleCancel}
                onConfirm={handleConfirm}
                dialogTitle={t('confirmation')}
                dialogContent={<p>{objectToAction.action_text}</p>}
            />
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <ScaleLoader
                            color="var(--primary)"
                            height={50}
                            radius={8}
                            width={4}
                        />
                    </div>
                </motion.div>
            )}
        </motion.div>
    )
}

export default UwPolicyInstallments